import {
  WaveBlockKind,
  collapsedBlockPreviewLabel,
  type WaveBlock,
  type WaveGalleryItem,
} from "@vida/wave-core";
import type { WaveWhaleTarget, WhaleWidgetAttachment } from "./waveWhale";

function galleryAttachments(items: WaveGalleryItem[] | undefined): WhaleWidgetAttachment[] {
  if (!items?.length) return [];
  return items
    .filter((item) => item.s3Key?.trim())
    .map((item) => ({
      s3Key: item.s3Key!.trim(),
      fileName: item.fileName?.trim() || item.s3Key!.split("/").pop() || "image",
      mime: item.mimeType?.trim() || "image/jpeg",
      ragStatus: "none",
    }));
}

function fileAttachment(block: WaveBlock): WhaleWidgetAttachment[] {
  const p = block.payload;
  if (!p.s3Key?.trim()) return [];
  return [
    {
      s3Key: p.s3Key.trim(),
      fileName: p.fileName?.trim() || p.s3Key.split("/").pop() || "file",
      mime: p.mimeType?.trim() || "application/octet-stream",
      ragStatus: p.ragStatus || "none",
    },
  ];
}

function blockTextForWhale(block: WaveBlock): string {
  const p = block.payload;
  if (p.text?.trim()) return p.text.trim();
  if (p.title?.trim()) return p.title.trim();
  if (p.fileName?.trim()) return p.fileName.trim();
  if (p.refTitle?.trim()) return p.refTitle.trim();
  return collapsedBlockPreviewLabel(block) || "";
}

function blockLabelForWhale(block: WaveBlock): string {
  const p = block.payload;
  if (p.fileName?.trim()) return p.fileName.trim();
  if (p.title?.trim()) return p.title.trim();
  if (p.refTitle?.trim()) return p.refTitle.trim();
  if (p.text?.trim()) {
    const line = p.text.trim().split("\n")[0];
    return line.length > 48 ? `${line.slice(0, 48)}…` : line;
  }
  return block.kind === WaveBlockKind.Text ? "Widget testo" : block.kind;
}

export function whaleTargetFromBlock(block: WaveBlock): WaveWhaleTarget {
  const widgetAttachments =
    block.kind === WaveBlockKind.Gallery
      ? galleryAttachments(block.payload.galleryItems)
      : block.kind === WaveBlockKind.File
        ? fileAttachment(block)
        : [];
  return {
    blockId: block.id,
    blockKind: block.kind,
    blockText: blockTextForWhale(block),
    blockLabel: blockLabelForWhale(block),
    widgetAttachments,
  };
}
